import { render, staticRenderFns } from "./UserGroupModules.vue?vue&type=template&id=6b95ecd2"
import script from "./UserGroupModules.vue?vue&type=script&lang=ts"
export * from "./UserGroupModules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports